import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class ShoppingCartPurchaseOrder {
    constructor(token) {
        this.backend = new Backend(token);
    }

    getCart(callback) {
        this.backend.callBackend(`${Endpoints.shoppingCartPurchaseOrder.private}/`,
            callback)
    }

    addPurcharseOrder(body,orderreferenceValue, callback) {
        const requestBody = {
            ...body, 
            "orderReference": orderreferenceValue,
         
        };
       
        this.backend.callBackend(`${Endpoints.shoppingCartPurchaseOrder.private}/purchase-order`,
            callback,
            'POST', requestBody);
    }

    addItem(amount, giftCardTypeId, quantity, variable, orderReferenceID, callback) {
        let body = {
            giftCardTypeId,
            quantity,
            "orderReference":orderReferenceID,
            amount:amount,
         
        }
        // if (variable) {
        //     body.amount = amount
        // }
        this.backend.callBackend(`${Endpoints.shoppingCartPurchaseOrder.private}/add`,
            callback,
            'POST',
            body);
    }

    removeItem(itemId, callback) {
        this.backend.callBackend(`${Endpoints.shoppingCartPurchaseOrder.private}/delete/${itemId}`, callback, 'DELETE')
    }

}